var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM9 8V5C9 4.45 9.45 4 10 4C10.55 4 11 4.45 11 5V8H12.79C13.24 8 13.46 8.54 13.14 8.85L10.35 11.64C10.15 11.84 9.84 11.84 9.64 11.64L6.85 8.85C6.7809 8.7795 6.73421 8.69013 6.71582 8.59314C6.69743 8.49616 6.70816 8.39589 6.74665 8.30499C6.78515 8.2141 6.8497 8.13663 6.93215 8.08235C7.01461 8.02807 7.11129 7.99942 7.21 8H9ZM14 15H6C5.45 15 5 14.55 5 14C5 13.45 5.45 13 6 13H14C14.55 13 15 13.45 15 14C15 14.55 14.55 15 14 15Z",
    fill: "#3AC430"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.4b6a0c3b5008ac76eb38ea61ef963569.svg";
export { ForwardRef as ReactComponent };